// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__4dgBm","panel":"Robot_panel__XJuMg","wrapper":"Robot_wrapper__35GHF","info":"Robot_info__OFdtT","unit":"Robot_unit__Oksed"};